import {AfterViewInit, Directive, ElementRef, OnDestroy} from '@angular/core';

@Directive({
  selector: '[cfForceFocus]',
})
export class ForceFocusDirective implements AfterViewInit, OnDestroy {

  private previousFocusedElement;

  constructor(private el: ElementRef) {
  }

  ngAfterViewInit() {
    if (document) {
      this.previousFocusedElement = document.activeElement;
    }
    this.el.nativeElement.focus();
  }

  ngOnDestroy() {
    if (this.previousFocusedElement) {
      this.previousFocusedElement.focus();
    }
  }
}
